import React, { useState, useRef } from 'react';
import FileArchiveActions, { dosyaUzantisi } from '../../../../components/FileArchiveActions';
import Box from '../../../../components/Box';
import { GetDriverByIdResponseFileArchive } from '../../../../models/response/driver/GetDriverByIdResponse';
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import toast from "react-hot-toast";
import { Helpers } from '../../../../helpers/Helpers';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { useDispatch } from 'react-redux';
import { storeAreYouSureModalCallback } from '../../../../redux/reducers/authSlice';
import { ConstantService } from '../../../../services/ConstantService';

interface Props {
    fileArchivesRef: any
    fileArchives: GetDriverByIdResponseFileArchive[]
    setFileArchives: React.Dispatch<React.SetStateAction<GetDriverByIdResponseFileArchive[]>>
}

const FileArchives = ({
    fileArchivesRef,
    fileArchives,
    setFileArchives,
}: Props) => {
    const dispatch = useDispatch();
    const [fileArchiveId, setFileArchiveId] = useState('');
    const [archiveFile, setArchiveFile] = useState<File | undefined>(undefined);
    const archiveFileRef: any = useRef();
    const [archiveFileName, setArchiveFileName] = useState<string | undefined>(undefined);
    const [archiveFileDescription, setArchiveFileDescription] = useState<string | undefined>(undefined);
    const [selectedFileArchiveType, setSelectedFileArchiveType] = useState<CustomSingleSelectModel | undefined>(undefined);
    const [isOpen, setIsOpen] = useState(false);

    const selectAll = () => {
        var isAllSelected = fileArchives.length == fileArchives.filter(x => x.isSelected).length;

        setFileArchives(fileArchives.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const deleteItems = () => {
        setFileArchives(fileArchives.filter(x => !x.isSelected));
    }

    const setItemSelected = (_id: string) => {
        setFileArchives(fileArchives.map(function (x) {
            if (x.fileArchiveId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    const setUpdateItem = () => {
        var o = fileArchives.filter(x => x.isSelected)[0];

        setFileArchiveId(o.fileArchiveId);
        setArchiveFile(undefined);

        if (archiveFileRef && archiveFileRef.current)
            archiveFileRef.current.value = "";

        setArchiveFileName(o.fileName)
        setSelectedFileArchiveType(o.fileTypeId && o.fileTypeName ? { label: o.fileTypeName, value: o.fileTypeId } : undefined);
        setArchiveFileDescription(o.description);
        setIsOpen(true);
        scrollTo();
    }

    const saveItem = () => {
        if (Helpers.isEmpty(fileArchiveId) && Helpers.isEmpty(archiveFile)) {
            toast.error('Dosya alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(archiveFileName)) {
            toast.error('Dosya Adı alanını doldurunuz!');
            return;
        }

        if (Helpers.isEmpty(fileArchiveId)) {
            var o: GetDriverByIdResponseFileArchive = {
                createdDate: undefined,
                description: archiveFileDescription,
                entityId: undefined,
                fileArchiveId: Helpers.generateUUID(),
                fileName: archiveFileName,
                fileTypeId: selectedFileArchiveType?.value,
                fileTypeName: selectedFileArchiveType?.label,
                url: undefined,
                fileArchiveFile: archiveFile,
                isSelected: false
            }

            setFileArchives([...fileArchives, o])
        }
        else {
            setFileArchives(fileArchives.map(function (x) {
                if (x.fileArchiveId == fileArchiveId) {
                    x.createdDate = new Date().toISOString();
                    x.description = archiveFileDescription;
                    x.fileName = archiveFileName;
                    x.fileTypeId = selectedFileArchiveType?.value;
                    x.fileTypeName = selectedFileArchiveType?.label;
                    x.fileArchiveFile = archiveFile;
                    x.isSelected = false;
                }

                return x;
            }))
        }

        setFileArchiveId('');
        setArchiveFile(undefined);

        if (archiveFileRef && archiveFileRef.current)
            archiveFileRef.current.value = "";

        setArchiveFileName('');
        setSelectedFileArchiveType(undefined);
        setArchiveFileDescription('');
        setIsOpen(false);
        scrollTo();
    }

    const cancelAdding = () => {
        if (!isOpen) {
            setIsOpen(true);
            scrollTo();
            return;
        }

        setFileArchiveId('');
        setArchiveFile(undefined);

        if (archiveFileRef && archiveFileRef.current)
            archiveFileRef.current.value = "";

        setArchiveFileName('');
        setSelectedFileArchiveType(undefined);
        setArchiveFileDescription('');
        setIsOpen(false);
        scrollTo();
    }

    const scrollTo = () => {
        var headerOffset = 120;
        var elementPosition = fileArchivesRef.current.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
        });
    }

    return (
        <div className='containerPart' ref={fileArchivesRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Dosya Arşiv</h4>

                    {
                        isOpen && (
                            <React.Fragment>
                                <div className='row'>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Dosya</label>
                                            <input ref={archiveFileRef} onChange={(e) => {
                                                if (e && e.target && e.target.files && e.target.files.length > 0) {
                                                    setArchiveFile(e.target.files[0]);
                                                    setArchiveFileName(e.target.files[0].name.split('.')[0]);
                                                }
                                                else {
                                                    setArchiveFile(undefined);
                                                    setArchiveFileName('');
                                                }
                                            }} style={{ border: '1px solid #F1F1F4' }} type="file" className="form-control form-control-solid" />
                                        </div>

                                        <div className="mt-5">
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Açıklama</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={archiveFileDescription} onChange={(e) => setArchiveFileDescription(e.target.value)} type="text" className="form-control form-control-solid" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Dosya Adı</label>
                                            <input style={{ border: '1px solid #F1F1F4' }} value={archiveFileName} onChange={(e) => setArchiveFileName(e.target.value)} type="text" className="form-control form-control-solid" />
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div>
                                            <label htmlFor="exampleFormControlInput1" className="form-label">Türü</label>

                                            <CustomSingleSelect
                                                selectedValue={selectedFileArchiveType}
                                                onChange={setSelectedFileArchiveType}
                                                insertable={{
                                                    onSubmit: { code: 'DRIVER_FILE_TYPE' }
                                                }}
                                                onMenuOpen={() => ConstantService.getConstantList('DRIVER_FILE_TYPE', undefined, undefined)}
                                                labelName='value'
                                                valueName='constantId'
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row mt-5">
                                    <div className="col-md-12">
                                        <Box alignItems="flex-end">
                                            <Box onClick={saveItem} className="actionIcon p-2 bg-success" justifyContent="center" flexDirection="row" borderRadius="4px">
                                                <Box mr="5px" justifyContent="center">
                                                    <i className="text-white fa fa-check" />
                                                </Box>
                                                <Box justifyContent="center">
                                                    <span style={{ fontWeight: 600 }} className="text-white">Kaydet</span>
                                                </Box>
                                            </Box>
                                        </Box>
                                    </div>
                                </div>

                                <Box className='ebbe-hr m-0 mt-5'>&nbsp;</Box>
                            </React.Fragment>
                        )
                    }

                    <Box className={isOpen ? "mt-5" : ""} flexDirection="row">
                        <Box onClick={cancelAdding} className={"actionIcon p-2 " + (!isOpen ? "bg-success" : "")} bg={isOpen ? 'orange' : undefined} justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className={"text-white fa " + (!isOpen ? 'fa-plus' : 'fa-times')} />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">{!isOpen ? 'Ekle' : 'İptal Et'}</span>
                            </Box>
                        </Box>

                        <Box onClick={fileArchives.filter(x => x.isSelected).length == 1 ? setUpdateItem : undefined} opacity={fileArchives.filter(x => x.isSelected).length == 1 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-primary" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-edit" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Güncelle</span>
                            </Box>
                        </Box>


                        <Box onClick={fileArchives.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={fileArchives.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} ml="10px" className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={fileArchives.filter(x => x.isSelected).length > 0 && fileArchives.filter(x => x.isSelected).length == fileArchives.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Dosya Adı</th>
                                            <th>Uzantı</th>
                                            <th>Türü</th>
                                            <th>Açıklama</th>
                                            <th>Yükleme Tarihi</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            fileArchives.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            fileArchives.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                                <input onChange={() => setItemSelected(item.fileArchiveId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.fileName}</td>
                                                    <td>{dosyaUzantisi(item.url)}</td>
                                                    <td>{item.fileTypeName}</td>
                                                    <td>{item.description}</td>
                                                    <td>{Helpers.dateParser(item.createdDate, true)}</td>
                                                    <td style={{ width: '1px' }}>
                                                        {
                                                            (!item.fileArchiveFile && item.entityId) && (
                                                                <FileArchiveActions url={item.url} fileName={item.fileName} />
                                                            )
                                                        }
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default FileArchives;